import { Controller } from '@hotwired/stimulus'
import BarReviewPerformanceStatsChannel from 'channels/bar_review/performance_stats_channel'

export default class extends Controller {
  static values = {
    scheduleId: String,
    updating: Boolean,
    withSubjects: Boolean
  }

  static targets = ["proficienciesBySubjectTable", "proficienciesTable", "alert"]

  initialize() {
    if (this.updatingValue) {
      const bySubjectTarget = this.withSubjectsValue ? this.proficienciesBySubjectTableTarget : null
      this.channel = new BarReviewPerformanceStatsChannel(this.scheduleIdValue, bySubjectTarget, this.proficienciesTableTarget, this.alertTarget)
      this.channel.start()
    }
  }
}
